import React from 'react';
import styled from 'styled-components';
import Button from './Button';

interface HeroProps {
  title: string;
  subtitle: string;
  backgroundImage: string;
  buttonText?: string;
  buttonLink?: string;
  scrollToId?: string; // Nouvelle propriété pour l'ID de la section à défiler
}

const Hero: React.FC<HeroProps> = ({
  title,
  subtitle,
  backgroundImage,
  buttonText,
  buttonLink,
  scrollToId,
}) => {
  // Fonction pour faire défiler jusqu'à la section spécifiée
  const handleScroll = () => {
    if (scrollToId) {
      const element = document.getElementById(scrollToId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };
  return (
    <HeroContainer backgroundImage={backgroundImage}>
      <HeroOverlay />
      <HeroContent>
        <HeroTitle>{title}</HeroTitle>
        <HeroSubtitle>{subtitle}</HeroSubtitle>
        {buttonText && (
          <HeroButton>
            {scrollToId ? (
              <Button onClick={handleScroll} size="large">
                {buttonText}
              </Button>
            ) : buttonLink ? (
              <Button to={buttonLink} size="large">
                {buttonText}
              </Button>
            ) : null}
          </HeroButton>
        )}
      </HeroContent>
    </HeroContainer>
  );
};

const HeroContainer = styled.div<{ backgroundImage: string }>`
  height: 100vh;
  min-height: 60rem;
  width: 100%;
  position: relative;
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2rem;
`;

const HeroOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0.3)
  );
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 80rem;
`;

const HeroTitle = styled.h1`
  color: #fff;
  font-size: 6rem;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    font-size: 4.5rem;
  }
  
  @media (max-width: 576px) {
    font-size: 3.5rem;
  }
`;

const HeroSubtitle = styled.p`
  color: #fff;
  font-size: 2.2rem;
  margin-bottom: 3rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const HeroButton = styled.div`
  margin-top: 2rem;
`;

export default Hero;
